import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IamAnswer } from "models/iam/iam-answer";
import { IamAsk } from "models/iam/iam-ask";
import { Observable } from "rxjs/Observable";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class IamDataService {
  private readonly iamServiceUrl: string;
  constructor(private http: HttpClient, private config: ConfigurationService) {
    if (this.config.getConfig().isLocal) {
      this.iamServiceUrl = config.getConfig().localEndpoints.iamServiceUrl;
    } else {
      this.iamServiceUrl = config.getConfig().apiUrl + "/iam";
    }
  }

  //DON'T USE THIS METHOD TO GET YOUR PERMISSIONS
  //USE AccessControlService getPermission METHOD INSTEAD
  public hasAccess(ask: IamAsk): Observable<IamAnswer> {
    return this.http.post<IamAnswer>(`${this.iamServiceUrl}`, ask);
  }
}



// WEBPACK FOOTER //
// ./src/providers/iam-service/iam.data.service.ts